<mat-card class="documents-panel mat-elevation-z2" [class.documents-panel-embedded]="embedded">
    <mat-card-content>
        <header class="documents-header" [class.documents-header-no-heading]="!showHeading">
            @if (showHeading) {
                <div>
                    <h2 class="documents-heading">Documents</h2>
                </div>
            }

            <div class="documents-header-actions">
                <button mat-icon-button type="button" class="documents-filter-button" [class.documents-filter-button-active]="filtersOpen || appliedFilterCount > 0" [matBadge]="appliedFilterCount" matBadgeOverlap="false" [matBadgeHidden]="appliedFilterCount === 0" matTooltip="Filter documents" aria-label="Filter documents" (click)="toggleFilters()">
                    <mat-icon>filter_alt</mat-icon>
                </button>

                <button mat-flat-button color="primary" type="button" *appCan="'add_documents'" (click)="openDocumentDialog()">
                    Create Document
                </button>
            </div>
        </header>

        @if (!canView) {
            <div class="documents-empty">You do not have permission to view documents for this record.</div>
        } @else {
            @if (filtersOpen) {
                <section class="documents-filter-tray" aria-label="Document filters">
                    <div class="documents-filter-tray-heading">
                        <span>Filter documents</span>
                        @if (appliedFilterCount > 0) {
                            <button mat-button type="button" (click)="clearFilters()">Clear</button>
                        }
                    </div>
                <section class="documents-filters" aria-label="Document filters">
                    <mat-form-field appearance="outline">
                        <mat-label>Category</mat-label>
                        <mat-select [(ngModel)]="filterCategory">
                            <mat-option value="">All categories</mat-option>
                            @for (category of categories; track category) {
                                <mat-option [value]="category">{{ category }}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Search title</mat-label>
                        <input matInput [(ngModel)]="filterTitle" placeholder="Search by title" />
                    </mat-form-field>
                </section>
                </section>
            }

            @if (loading) {
                <div class="documents-empty">Loading documents…</div>
            } @else if (!filteredDocuments.length) {
                <div class="documents-empty">
                    {{ documents.length ? 'No documents match the selected filters.' : 'No documents have been added yet.' }}
                </div>
            } @else {
                <div class="documents-list">
                    @for (document of filteredDocuments; track document.id) {
                        <article class="document-row">
                            <div class="document-main">
                                <div class="document-title">{{ document.title || document.file_name }}</div>
                                <div class="document-meta">
                                    @if (document.category) {
                                        <mat-chip>{{ document.category }}</mat-chip>
                                    }
                                    <span>{{ formatSize(document.size) }}</span>
                                    <span>Uploaded by {{ uploadedBy(document) }} on {{ document.created_at | date: 'd/MM/yyyy h:mma' }}</span>
                                </div>
                            </div>

                            <div class="document-visibility">
                                <span class="document-visibility-label">Visible to</span>
                                <mat-button-toggle-group
                                    *appCan="'manage_document_visibility'"
                                    multiple
                                    class="document-visibility-toggles"
                                    aria-label="Document visibility"
                                    [disabled]="visibilitySaving.has(document.id)"
                                    [value]="visibilityValues(document)"
                                    (change)="updateVisibility(document, $event.value)"
                                >
                                    <mat-button-toggle value="customer">Customer</mat-button-toggle>
                                    <mat-button-toggle value="app">App</mat-button-toggle>
                                    <mat-button-toggle value="report">Report</mat-button-toggle>
                                </mat-button-toggle-group>
                                @if (!canManageVisibility) {
                                    <div class="document-visibility-values" aria-label="Document visibility">
                                        @if (document.visible_to_customer) {
                                            <span>Customer</span>
                                        }
                                        @if (document.visible_on_app) {
                                            <span>App</span>
                                        }
                                        @if (document.include_in_report) {
                                            <span>Report</span>
                                        }
                                        @if (!document.visible_to_customer && !document.visible_on_app && !document.include_in_report) {
                                            <span>Internal only</span>
                                        }
                                    </div>
                                }
                            </div>

                            <div class="document-actions">
                                <button mat-icon-button type="button" matTooltip="Edit" *appCan="'edit_documents'" (click)="openDocumentDialog(document)"><mat-icon>edit</mat-icon></button>
                                <button mat-icon-button type="button" matTooltip="Download" (click)="download(document)"><mat-icon>download</mat-icon></button>
                                <button mat-icon-button type="button" color="warn" matTooltip="Delete" *appCan="'delete_documents'" (click)="delete(document)"><mat-icon>delete</mat-icon></button>
                            </div>
                        </article>
                    }
                </div>
            }
        }
    </mat-card-content>
</mat-card>
